import { render, staticRenderFns } from "./MatchBackHomeButton.vue?vue&type=template&id=8c65cc24&scoped=true"
import script from "./MatchBackHomeButton.vue?vue&type=script&lang=js"
export * from "./MatchBackHomeButton.vue?vue&type=script&lang=js"
import style0 from "./MatchBackHomeButton.vue?vue&type=style&index=0&id=8c65cc24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c65cc24",
  null
  
)

export default component.exports